function toggleV(menuId) {
    const menu = document.getElementById(menuId);
    const menuHeader = document.querySelector(`[onclick="toggleV('${menuId}')"]`);

    if (menu) {
        const shouldExpand = menu.style.display === 'none' || menu.style.display === '';
        menu.style.display = shouldExpand ? 'block' : 'none';
        menuHeader.setAttribute('aria-expanded', shouldExpand.toString());

        const otherMenus = Array.from(document.querySelectorAll(`div.single-menu>div.menu-body:not(#${menuId})`));
        otherMenus.forEach(otherMenu => otherMenu.style.display = 'none');
    }
}

document.addEventListener("DOMContentLoaded", function() {
    var urlLastPart = window.location.href;
    var afterSlashAfter = urlLastPart.substring(urlLastPart.lastIndexOf('/') + 1);
    console.log(urlLastPart, afterSlashAfter)

    var checkboxes = Array.from(document.querySelectorAll(".filter_tags_list input[type='checkbox']"));
    console.log('check', checkboxes);
    checkboxes.forEach(function(checkbox) {
        var str2 = checkbox.id;
        if(afterSlashAfter.indexOf(str2) != -1){
            checkbox.checked = true;
        }
    });
    
    var nbpAllArticles = document.querySelector(".main-blog");
    var nbpSingleSlider = Array.from(document.querySelectorAll(".nbp-single-slider"));
    var nbp3blogs = Array.from(document.querySelectorAll(".nbp-3blogs"));

    console.log('All sections',nbpAllArticles,nbpSingleSlider,nbp3blogs)

    
    if(nbpAllArticles) {
        nbpAllArticles.style.display = "none";
    }
    if(nbpSingleSlider) {
        nbpSingleSlider.forEach(function(section) { section.style.display = "none"; });
    }
    if(nbp3blogs) {
        nbp3blogs.forEach(function(section) { section.style.display = "none"; });
    }

    if (window.location.href.indexOf("tagged") > -1) {
        nbpAllArticles.style.display = "block";
    } else {
        nbpSingleSlider.forEach(function(section) { section.style.display = "block"; });
        nbp3blogs.forEach(function(section) { section.style.display = "block"; });
    }
});
